import { ActiveExperimentName, ActiveExperimentsByName } from './types';
import { useExperiments } from './useExperiments';

export default function useExperiment<TName extends ActiveExperimentName>(
  name: TName,
): ActiveExperimentsByName[TName] | undefined {
  const { data } = useExperiments();
  return data?.[name];
}
